const Api = `${process.env.REACT_APP_apiUrl}/Suscription`;

function sendSubscription(email) {
  return fetch(Api, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      email,
    }),
  });
}

export { sendSubscription };
